import React from 'react';

import { attachmentPreviewPropTypes } from '../../../utils/attachments';

import { StyledVideo } from './styles';

const defaultVideoType = 'video/mp4';

const VideoAttachment = ({ assetLocalUrl, attachmentData }) => (
  <StyledVideo controls>
    <source src={assetLocalUrl} type={attachmentData.mimeType} />
    <source src={assetLocalUrl} type={defaultVideoType} />
  </StyledVideo>
);

VideoAttachment.propTypes = attachmentPreviewPropTypes;

VideoAttachment.defaultProps = {};

export default VideoAttachment;
